module.exports = __webpack_public_path__ + "static/media/Luigi.6603d254.gif";